import RequestAbstract from "./RequestAbstract";

export default class AccountHistory extends RequestAbstract {
    get link() {
        return this.links.accountHistory;
    }

    async getAllForClient(clientId, showCanceled, sort) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
        ];

        if (!showCanceled)
            arr.push({ field: "direction", op: "!=", value: "DIRECTION_CANCEL" });

        return this.getAllFiltered([arr], this.getSortField(sort));
    }

    async getAllForInvoice(invoiceId) {
        const arr = [
            { field: "invoiceId", op: "=", value: invoiceId },
            { field: "direction", op: "=", value: "DIRECTION_SUBSTRACT" },
        ];

        return this.getAllFiltered([arr]);
    }

}
